module.exports = __webpack_public_path__ + "1cdbae80128a01859971211fa7998dd0.png";